<script setup lang="ts">
  import { computed } from 'vue';
  import { useHttpClient, useShared, useRoute } from '@othercommerce/foundation';

  const props = defineProps({
    variant: { type: Number, required: true },
  });

  const route = useRoute();
  const shared = useShared();
  const http = useHttpClient();

  const compared = computed(() => {
    if (props.variant && shared.value.comparator) {
      return shared.value.comparator.map((c: any) => c.variant_id).includes(props.variant);
    } else {
      return false;
    }
  });

  function toggle() {
    if (compared.value) {
      http.delete(route('web.comparator.destroy', { 'variantId': props.variant }));
    } else {
      http.post(route('web.comparator.store', { 'variantId': props.variant }));
    }
  }
</script>
<template>
  <div class="compare" @click.prevent.stop="toggle">
    <slot v-bind="{ compared }">
      <SfButton class="compare__button" :class="{ compared }" rounded small square transparent>
        <template #after>
          <SfIconScale aria-hidden="true" />
        </template>
      </SfButton>
    </slot>
  </div>
</template>
<style scoped lang="scss">
  @use "@storefront/styles/mixins/media";

  .compare {
    display: contents;
    font-size: 1.125rem;

    &__button {

      @media(hover: hover) {
        &:hover {
          color: var(--color-primary);
        }
      }

      &.compared {
        color: var(--danger-color);

        @media(hover: hover) {
          &:hover {
            color: var(--danger-color-hover);
          }
        }
      }
    }
  }
</style>
